import React, { Component } from "react";
import { NavLink, Link } from "react-router-dom";
import { connect } from "react-redux";

import SearchInventoryBar from "../../components/generics/SearchInventoryBar";
import UIIcon from "../../components/generics/UIIcon";
import Spinner from "../../components/generics/Spinner";
import { fetchCurrentUser, fetchCurrentUserSuccess, fetchCurrentUserFailure } from "../../store/auth/actions";
import {
  SHIPMENTREPORT,
  OFFERLIST,
  CAN_USE_VENDOR_OFFERS,
  CAN_LIST_R365_REPORTS,
  checkAnyPermissions,
  hasPermission,
} from "../../utils/permissons";

import { withRouter } from "../../utils/WithRouter";
import { canUseRefinedAppUI } from "../../utils/featureFlags";

export class Sidebar extends Component {
  // ---------------------------------------------------------------------------
  // Initialization
  // ---------------------------------------------------------------------------
  constructor(props) {
    super(props);
    const refinedUI = props.refinedUI === undefined ? canUseRefinedAppUI(props.currentUser) : props.refinedUI;
    this.state = {
      dropdownOpen: this.props.location.pathname.match("^/reports")
        && !((props.refinedUI === undefined ? canUseRefinedAppUI(props.currentUser) : props.refinedUI)
          && /^\/reports\/inventory\/?$/.test(props.location.pathname)) ? true : false,
      dropdownInvoice:
        this.props.location.pathname.match("^/invoice") ||
        this.props.location.pathname.match("^/credit_note") ||
        this.props.location.pathname.match("^/purchase_orders") ||
        this.props.location.pathname.match("^/pending_inventory") ||
        (refinedUI && /^\/(price_lists|compare_price_lists)(\/|$)/.test(this.props.location.pathname))
          ? true
          : false,
      dropdownShipping: this.props.location.pathname.match("^/shipping") || this.props.location.pathname.match("^/return")
        || (refinedUI && /^\/shipment(\/|$)/.test(this.props.location.pathname)) ? true : false,
      dropdownOrders: this.props.location.pathname.match("^/orders") ? true : false,
      dropdownMarketInventory: this.props.location.pathname.match("^/market-inventory") ? true : false,
      dropdownMaintenance: this.props.location.pathname.match("^/maintenance") ? true : false,
    };
  }

  componentDidMount() {
    this.props.fetchCurrentUser();
  }
  // ---------------------------------------------------------------------------
  // Dropdowns
  // ---------------------------------------------------------------------------
  toggleDropdown = () => {
    this.setState((prevState) => ({
      dropdownOpen: !prevState.dropdownOpen,
      dropdownInvoice: false,
      dropdownShipping: false,
      dropdownOrders: false,
      dropdownMarketInventory: false,
      dropdownMaintenance: false,
    }));
  };

  toggleDropdownInvoice = () => {
    this.setState((prevState) => ({
      dropdownInvoice: !prevState.dropdownInvoice,
      dropdownOpen: false,
      dropdownShipping: false,
      dropdownOrders: false,
      dropdownMarketInventory: false,
      dropdownMaintenance: false,
    }));
  };

  toggleDropdownShipping = () => {
    this.setState((prevState) => ({
      dropdownShipping: !prevState.dropdownShipping,
      dropdownOpen: false,
      dropdownInvoice: false,
      dropdownOrders: false,
      dropdownMarketInventory: false,
      dropdownMaintenance: false,
    }));
  };

  toggleDropdownOrders = () => {
    this.setState((prevState) => ({
      dropdownOrders: !prevState.dropdownOrders,
      dropdownShipping: false,
      dropdownOpen: false,
      dropdownInvoice: false,
      dropdownMarketInventory: false,
      dropdownMaintenance: false,
    }));
  };

  toggleDropdownMarketInventory = () => {
    this.setState((prevState) => ({
      dropdownMarketInventory: !prevState.dropdownMarketInventory,
      dropdownOpen: false,
      dropdownInvoice: false,
      dropdownShipping: false,
      dropdownOrders: false,
      dropdownMaintenance: false,
    }));
  };

  toggleDropdownMaintenance = () => {
    this.setState((prevState) => ({
      dropdownMaintenance: !prevState.dropdownMaintenance,
      dropdownOpen: false,
      dropdownInvoice: false,
      dropdownShipping: false,
      dropdownOrders: false,
      dropdownMarketInventory: false,
    }));
  };

  sidebarToggle = () => {
    const refinedUI = this.props.refinedUI === undefined
      ? canUseRefinedAppUI(this.props.currentUser) : this.props.refinedUI;
    if (refinedUI) document.body.classList.remove("sidebar-mobile-show");
    else document.body.classList.toggle("sidebar-mobile-show");
  };

  // ---------------------------------------------------------------------------
  // Search
  // ---------------------------------------------------------------------------
  goToInventory = (id) => {
    this.props.history.push(`/inventory/${id}`);
    if (this.props.match.path === "/inventory/:id") {
      this.props.history.go();
    }
  };

  // ---------------------------------------------------------------------------
  // Render
  // ---------------------------------------------------------------------------
  render() {
    const { user, loading } = this.props.currentUser;
    const refinedUI = this.props.refinedUI === undefined
      ? canUseRefinedAppUI(this.props.currentUser)
      : this.props.refinedUI;
    const {
      hasPermission: checkPermission = hasPermission,
      checkAnyPermissions: checkPermissions = checkAnyPermissions,
    } = this.props;
    const DropdownControl = refinedUI ? 'button' : 'span';
    const navIcon = (legacyClass, name) => refinedUI
      ? <UIIcon name={name} /> : <i className={legacyClass}></i>;
    const inventoryActive = /^\/(reports\/inventory|inventory\/\d+)\/?$/.test(this.props.location.pathname);
    // "Order List" stays current on order details, but not on Holiday Catering.
    const holidayCateringActive = /^\/orders\/holiday-catering(\/|$)/.test(this.props.location.pathname);
    if (!user || loading) {
      return <Spinner />;
    } else {
      return (
        <div className="sidebar">
          <nav className="sidebar-nav">
            <ul className="nav">
              {user.is_plant_user && (
                <li className="nav-item">
                  {/* Inventory Search */}
                  <SearchInventoryBar goToInventory={this.goToInventory} refinedUI={refinedUI} />
                </li>
              )}

              {refinedUI && user.is_superuser && (
                <li className="nav-item">
                  <Link to="/reports/inventory" className="nav-link" onClick={this.sidebarToggle}
                    aria-current={inventoryActive ? 'page' : undefined}>
                    <UIIcon name="inventory" />Inventory
                  </Link>
                </li>
              )}

              {/* Orders */}
              <li className={`nav-item nav-dropdown ${this.state.dropdownOrders ? "open" : ""}`}>
                <DropdownControl className="nav-link nav-dropdown-toggle" onClick={this.toggleDropdownOrders}
                    type={refinedUI ? 'button' : undefined} aria-expanded={refinedUI ? this.state.dropdownOrders : undefined}>
                  {navIcon('fa fa-list-alt', 'orders')}Orders
                {refinedUI && <UIIcon name="chevronDown" size={14} className="nav-chevron" />}
                </DropdownControl>
                <ul className="nav-dropdown-items" hidden={refinedUI && !this.state.dropdownOrders}>
                  <li className="nav-item">
                    <NavLink end={holidayCateringActive} to={"/orders"} className="nav-link" onClick={this.sidebarToggle}>
                      {navIcon('fa fa-file-text-o', 'document')}Order List
                    </NavLink>
                  </li>
                  {!user.is_delivery_user && (
                    <li className="nav-item">
                      <NavLink to={"/orders/holiday-catering"} className="nav-link" onClick={this.sidebarToggle}>
                        {navIcon('fa fa-gift', 'calendar')}Holiday Catering
                      </NavLink>
                    </li>
                  )}
                </ul>
              </li>

              {/* Market Inventory - visible to all users for testing */}
              {user && (
                <li className={`nav-item nav-dropdown ${this.state.dropdownMarketInventory ? "open" : ""}`}>
                  <DropdownControl className="nav-link nav-dropdown-toggle" onClick={this.toggleDropdownMarketInventory}
                    type={refinedUI ? 'button' : undefined} aria-expanded={refinedUI ? this.state.dropdownMarketInventory : undefined}>
                    {navIcon('fa fa-barcode', 'inventory')}Market Inventory
                  {refinedUI && <UIIcon name="chevronDown" size={14} className="nav-chevron" />}
                </DropdownControl>
                  <ul className="nav-dropdown-items" hidden={refinedUI && !this.state.dropdownMarketInventory}>
                    <li className="nav-item">
                      <NavLink to={"/market-inventory/scanner"} className="nav-link" onClick={this.sidebarToggle}>
                        {navIcon('fa fa-qrcode', 'scan')}Scanner
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink to={"/market-inventory/stock-levels"} className="nav-link" onClick={this.sidebarToggle}>
                        {navIcon('fa fa-cubes', 'inventory')}Stock Levels
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink to={"/market-inventory/alerts"} className="nav-link" onClick={this.sidebarToggle}>
                        {navIcon('fa fa-exclamation-triangle', 'warning')}Alerts
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink to={"/market-inventory/consumption"} className="nav-link" onClick={this.sidebarToggle}>
                        {navIcon('fa fa-line-chart', 'chart')}Consumption History
                      </NavLink>
                    </li>
                  </ul>
                </li>
              )}

              {/* Maintenance - visible to plant users and superusers */}
              {(user.is_plant_user || user.is_superuser) && (
                <li className={`nav-item nav-dropdown ${this.state.dropdownMaintenance ? "open" : ""}`}>
                  <DropdownControl className="nav-link nav-dropdown-toggle" onClick={this.toggleDropdownMaintenance}
                    type={refinedUI ? 'button' : undefined} aria-expanded={refinedUI ? this.state.dropdownMaintenance : undefined}>
                    {navIcon('fa fa-wrench', 'maintenance')}Maintenance
                  {refinedUI && <UIIcon name="chevronDown" size={14} className="nav-chevron" />}
                </DropdownControl>
                  <ul className="nav-dropdown-items" hidden={refinedUI && !this.state.dropdownMaintenance}>
                    <li className="nav-item">
                      <NavLink end={refinedUI} to={"/maintenance"} className="nav-link" onClick={this.sidebarToggle}>
                        {navIcon('fa fa-dashboard', 'dashboard')}Dashboard
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink to={"/maintenance/tasks"} className="nav-link" onClick={this.sidebarToggle}>
                        {navIcon('fa fa-calendar-check-o', 'calendar')}Today's Tasks
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink to={"/maintenance/machines"} className="nav-link" onClick={this.sidebarToggle}>
                        {navIcon('fa fa-cogs', 'maintenance')}Machines
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink to={"/maintenance/facilities"} className="nav-link" onClick={this.sidebarToggle}>
                        {navIcon('fa fa-building', 'building')}Facilities
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink to={"/maintenance/task-templates"} className="nav-link" onClick={this.sidebarToggle}>
                        {navIcon('fa fa-clipboard', 'orders')}Task Templates
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink to={"/maintenance/task-assignments"} className="nav-link" onClick={this.sidebarToggle}>
                        {navIcon('fa fa-link', 'link')}Task Assignments
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink to={"/maintenance/records"} className="nav-link" onClick={this.sidebarToggle}>
                        {navIcon('fa fa-list', 'orders')}Records
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink to={"/maintenance/settings"} className="nav-link" onClick={this.sidebarToggle}>
                        {navIcon('fa fa-cog', 'settings')}Settings
                      </NavLink>
                    </li>
                  </ul>
                </li>
              )}

              {((user.is_market_user && checkPermission(OFFERLIST, CAN_USE_VENDOR_OFFERS)) || user.is_plant_user) && (
                <div>
                  {/* Receiving */}
                  <li className={`nav-item nav-dropdown ${this.state.dropdownInvoice ? "open" : ""}`}>
                    <DropdownControl className="nav-link nav-dropdown-toggle" onClick={this.toggleDropdownInvoice}
                    type={refinedUI ? 'button' : undefined} aria-expanded={refinedUI ? this.state.dropdownInvoice : undefined}>
                      {navIcon('fa fa-list-alt', 'receiving')}Receiving
                    {refinedUI && <UIIcon name="chevronDown" size={14} className="nav-chevron" />}
                </DropdownControl>
                    <ul className="nav-dropdown-items" hidden={refinedUI && !this.state.dropdownInvoice}>
                      {user.is_plant_user && (
                        <div>
                          <li className="nav-item">
                            <NavLink to={"/invoice"} className="nav-link" onClick={this.sidebarToggle}>
                              {navIcon('fa fa-file-text-o', 'document')}Invoices
                            </NavLink>
                          </li>
                          <li className="nav-item">
                            <NavLink to={"/credit_note"} className="nav-link" onClick={this.sidebarToggle}>
                              {navIcon('fa fa-arrow-circle-right', 'return')}Credit Notes
                            </NavLink>
                          </li>
                        </div>
                      )}

                      <li className="nav-item">
                        <NavLink to={"/purchase_orders"} className="nav-link" onClick={this.sidebarToggle}>
                          {navIcon('fa fa-archive', 'inventory')}Purchase Orders
                        </NavLink>
                      </li>
                      {user.is_plant_user && (
                        <div>
                          <li className="nav-item">
                            <NavLink to={"/pending_inventory"} className="nav-link" onClick={this.sidebarToggle}>
                              {navIcon('fa fa-tasks', 'audit')}Pending Inventory
                            </NavLink>
                          </li>
                          {checkPermission(OFFERLIST, CAN_USE_VENDOR_OFFERS) && (
                            <>
                              <li className="nav-item">
                                <NavLink to={"/price_lists"} className="nav-link" onClick={this.sidebarToggle}>
                                  {navIcon('fa fa-wpforms', 'document')}Price Lists
                                </NavLink>
                              </li>
                              <li className="nav-item">
                                <NavLink to={"/price_lists/correction-rules"} className="nav-link" onClick={this.sidebarToggle}>
                                  {navIcon('fa fa-magic', 'settings')}Correction Rules
                                </NavLink>
                              </li>
                            </>
                          )}
                        </div>
                      )}
                    </ul>
                  </li>
                </div>
              )}

              {user.is_plant_user && (
                <div>
                  {/* Production */}
                  <li className="nav-item">
                    <NavLink to={"/session"} className="nav-link" onClick={this.sidebarToggle}>
                      {navIcon('fa fa-industry', 'production')}Production
                    </NavLink>
                  </li>

                  {/* Shipping */}
                  <li className={`nav-item nav-dropdown ${this.state.dropdownShipping ? "open" : ""}`}>
                    <DropdownControl className="nav-link nav-dropdown-toggle" onClick={this.toggleDropdownShipping}
                    type={refinedUI ? 'button' : undefined} aria-expanded={refinedUI ? this.state.dropdownShipping : undefined}>
                      {navIcon('fa fa-truck', 'shipping')}Shipping
                    {refinedUI && <UIIcon name="chevronDown" size={14} className="nav-chevron" />}
                </DropdownControl>
                    <ul className="nav-dropdown-items" hidden={refinedUI && !this.state.dropdownShipping}>
                      <li className="nav-item">
                        <NavLink to={"/shipment"} className="nav-link" onClick={this.sidebarToggle}>
                          {navIcon('fa fa-file-text-o', 'document')}Shippings
                        </NavLink>
                      </li>
                      <li className="nav-item">
                        <NavLink to={"/return"} className="nav-link" onClick={this.sidebarToggle}>
                          {navIcon('fa fa-arrow-circle-left', 'return')}Returns
                        </NavLink>
                      </li>
                    </ul>
                  </li>

                  {/* Inventory Audit */}
                  <li className="nav-item">
                    <NavLink to={"/inventory/audit"} className="nav-link" onClick={this.sidebarToggle}>
                      {navIcon('fa fa-list-ol', 'audit')}Inventory Audit
                    </NavLink>
                  </li>

                  {/* Locations */}
                  <li className="nav-item">
                    <NavLink to={"/inventory/locations"} className="nav-link" onClick={this.sidebarToggle}>
                      {navIcon('fa fa-thumb-tack', 'location')}Locations
                    </NavLink>
                  </li>
                </div>
              )}

              {/* Reports */}
              {(user.is_superuser || checkPermissions([{ model: SHIPMENTREPORT, perms: [CAN_LIST_R365_REPORTS] }])) && (
                <li className={`nav-item nav-dropdown ${this.state.dropdownOpen ? "open" : ""}`}>
                  <DropdownControl className="nav-link nav-dropdown-toggle" onClick={this.toggleDropdown}
                    type={refinedUI ? 'button' : undefined} aria-expanded={refinedUI ? this.state.dropdownOpen : undefined}>
                    {navIcon('fa fa-list-alt', 'chart')}Reports
                  {refinedUI && <UIIcon name="chevronDown" size={14} className="nav-chevron" />}
                </DropdownControl>
                  <ul className="nav-dropdown-items" hidden={refinedUI && !this.state.dropdownOpen}>
                    {user.is_superuser && (
                      <li className="nav-item">
                        <NavLink
                          to={"/reports/expired_inventories"}
                          className="nav-link"
                          onClick={this.sidebarToggle}

                        >
                          {navIcon('fa fa-calendar-times-o', 'calendar')}Expiration Report
                        </NavLink>
                      </li>
                    )}
                    {user.is_superuser && !refinedUI && (
                      <li className="nav-item">
                        <NavLink to={"/reports/inventory"} className="nav-link" onClick={this.sidebarToggle}>
                          <i className="icon-tag"></i>Inventory Report
                        </NavLink>
                      </li>
                    )}
                    {user.is_superuser && (
                      <li className="nav-item">
                        <NavLink to={"/reports/invoices"} className="nav-link" onClick={this.sidebarToggle}>
                          <i className="icon-docs"></i>Invoices Report
                        </NavLink>
                      </li>
                    )}
                    {user.is_superuser && (
                      <li className="nav-item">
                        <NavLink to={"/reports/inventory_items"} className="nav-link" onClick={this.sidebarToggle}>
                          <i className="icon-check"></i>Items on inventory
                        </NavLink>
                      </li>
                    )}
                    {user.is_superuser && (
                      <li className="nav-item">
                        <NavLink to={"/reports/production"} className="nav-link" onClick={this.sidebarToggle}>
                          {navIcon('fa fa-line-chart', 'chart')}Production Report
                        </NavLink>
                      </li>
                    )}
                    {user.is_superuser && (
                      <li className="nav-item">
                        <NavLink to={"/reports/shipment"} className="nav-link" onClick={this.sidebarToggle}>
                          <i className="icon-graph"></i>Shipments Report
                        </NavLink>
                      </li>
                    )}
                    {user.is_superuser && (
                      <li className="nav-item">
                        <NavLink to={"/reports/waste"} className="nav-link" onClick={this.sidebarToggle}>
                          {navIcon('fa fa-trash', 'trash')}Waste Report
                        </NavLink>
                      </li>
                    )}
                    {user.is_superuser && (
                      <li className="nav-item">
                        <NavLink to={"/reports/yield"} className="nav-link" onClick={this.sidebarToggle}>
                          {navIcon('fa fa-align-left', 'layers')}Yield Report
                        </NavLink>
                      </li>
                    )}
                    {user.is_superuser && (
                      <li className="nav-item">
                        <NavLink to={"/reports/ingredients"} className="nav-link" onClick={this.sidebarToggle}>
                          {navIcon('fa fa-balance-scale', 'scale')}Ingredients Report
                        </NavLink>
                      </li>
                    )}
                    {user.is_superuser && (
                      <li className="nav-item">
                        <NavLink to={"/reports/receiving"} className="nav-link" onClick={this.sidebarToggle}>
                          {navIcon('fa fa-level-down', 'receiving')}Receiving Report
                        </NavLink>
                      </li>
                    )}
                    {(user.is_superuser || checkPermission(SHIPMENTREPORT, CAN_LIST_R365_REPORTS)) && (
                      <li className="nav-item">
                        <NavLink to={"/reports/R365"} className="nav-link" onClick={this.sidebarToggle}>
                          {navIcon('fa fa-plug', 'link')}R365
                        </NavLink>
                      </li>
                    )}
                    {user.is_superuser && (
                      <li className="nav-item">
                        <NavLink to={"/reports/weighted_price"} className="nav-link" onClick={this.sidebarToggle}>
                          {navIcon('fa fa-book', 'document')}Weighted Price
                        </NavLink>
                      </li>
                    )}
                    {user.is_superuser && (
                      <li className="nav-item">
                        <NavLink to={"/reports/recall?page=1"} className="nav-link" onClick={this.sidebarToggle}>
                          {navIcon('fa fa-bullhorn', 'warning')}Recall Report
                        </NavLink>
                      </li>
                    )}
                  </ul>
                </li>
              )}
            </ul>
          </nav>
        </div>
      );
    }
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    currentUser: state.auth.currentUser,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchCurrentUser: () => {
      dispatch(fetchCurrentUser()).payload.then(
        (response) => {
          dispatch(fetchCurrentUserSuccess(response.data));
        },
        (error) => {
          dispatch(fetchCurrentUserFailure(error));
        }
      );
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Sidebar));
